import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CheckoutHeader from "../eazy-peasy-checkout/components/shared/CheckoutHeader";
import OrderStatus from "./components/OrderStatus";
import { formatDate } from "../../utils/utils";
import YourBillWidget from "./components/YourBillWidget";
import { formatCurrency } from "../../utils/utils";
import CartItemsWithModifiers from "./components/CartItemsWithModifiers";
import { useSelector } from "react-redux";
import { DojoCartItemsWithModifiers } from "../../components/dojo";

const PastOrderDetailsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const orderId = location.state?.order?._id;
  const order_rest_id = location.state?.order?._idRestaurant;
  const restaurantDetail = useSelector(state => state.restaurantData.restaurantDetail);
  const themeColors = restaurantDetail?.themeColors;

  const {
    orderDetailBgColor = null,
    orderDetailCardBgColor = null,
    orderDetailCardFontColor = null,
    orderDetailHeaderBgColor = null,
    orderDetailHeaderFontColor = null,
    orderDetailCardBillWidgetBgColor = null,
    orderDetailCardBillWidgetFontColor = null,
  } = themeColors || {};

  const pastOrders = JSON.parse(localStorage.getItem("pastOrders"));
  const order = pastOrders.find((item) => item._id === orderId);

  const handleBackButtonClick = () => {
    if (location?.state?.from) {
      navigate("/restaurant/past-orders", {
        state: {
          from: location?.state?.from,
        },
      });
    } else navigate("/restaurant/past-orders");
  };

  if (!order) {
    return <Typography>Order not found</Typography>;
  }
  return (
    <Box className={"device-width-view"}>
      <Box className={"device-width-pct"}>
        <CheckoutHeader
          headerTitle="Your Orders"
          onBackButtonClick={handleBackButtonClick}
          bgColor={orderDetailHeaderBgColor ?? "#FFF"}
          fontColor={orderDetailHeaderFontColor ?? "#000"}
        />
      </Box>

      <Box
        className={"device-width-pct"}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          height: "100vh",
          boxSizing: "border-box",
          maxHeight: "100vh",
          overflowY: "auto",
          backgroundColor: orderDetailBgColor ?? "#FAFBFF",
        }}
      >
        <Box sx={{
          mt: 2,
          fontSize: '14px',
          fontFamily: 'Inter',
          fontWeight: 700,
          textTransform: 'uppercase',
          maxWidth: '80%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          alignSelf: 'center',
          textAlign: 'center',
          mx: 'auto',

        }}>{order_rest_id === restaurantDetail?._id ? restaurantDetail?.name : ""}</Box>
        <Box
          sx={{
            p: 2,
            mx: 1,
            mt: 0.75,
            backgroundColor: orderDetailCardBgColor ?? "white",
            boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.1)",
            borderRadius: "15px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: orderDetailCardFontColor ?? "#000",
                fontWeight: 600,
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 1,
              }}
            >
              Order:{" "}
              {order?.orderRef ?? `#${order?._id?.toUpperCase().substr(-5)}`}
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <OrderStatus status={order?.transactionStatus} />
            </Box>
          </Box>
          {order && order?.cart?.length && order?.cart?.[0]?.count ? (
            <CartItemsWithModifiers
              cartList={order?.cart}
              fontColor={orderDetailCardFontColor}
            />
          ) : (
            <DojoCartItemsWithModifiers
              cartList={order?.cart}
              fontColor={orderDetailCardFontColor}
            />
          )}

          <Typography
            sx={{
              color: orderDetailCardFontColor ?? "#000",
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: 12,
              lineHeight: 1,
              py: 1,
              textAlign: "center",
            }}
          >
            Placed at {formatDate(order?.createdAt)} on Table{" "}
            {order?.tableNumber}
          </Typography>
        </Box>

        <Box sx={{}}>
          <YourBillWidget
            totalCartPrice={formatCurrency(order?.remainingToPay || order?.totalAmount)}
            subTotal={order?.totalCartAmount}
            couponDiscountAmount={order?.couponDiscountAmount || 0}
            discount={order?.discountAmount || 0}
            taxValue={order?.tax || 0}
            tipValue={order?.tip || 0}
            serviceCharge={order?.serviceCharge || 0}
            restTemplate="temp1"
            bgColor={orderDetailCardBillWidgetBgColor}
            fontColor={orderDetailCardBillWidgetFontColor}
            charges={order?.charges || []}
            transactionStatus={order?.transactionStatus}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PastOrderDetailsPage;
